// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPageLoader_root__8P0cU","bg":"FullPageLoader_bg__3eLIx","fg":"FullPageLoader_fg__-lmT7","fg-spin":"FullPageLoader_fg-spin__2SFrl"};